import { useState, useCallback } from 'react'
import { Dropdown, DropdownItem, DropdownToggle, DropdownMenu, Input } from 'reactstrap'

import styles from './SelectBox.module.scss'

import type { FocusEvent } from 'react'

export type Item<T extends string | number = string> = {
  key?: T
  value: string
}

type Props<T extends string | number = string> = {
  id: string
  items: Item<T>[]
  value: string | undefined
  onSelect: (item: Item<T>) => void
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
  invalid?: boolean
  placeholder?: string
  disabled?: boolean
  className?: string
}

export const SelectBox = <T extends string | number>({
  id,
  items = [],
  value = '',
  onSelect,
  onBlur = () => {},
  invalid = false,
  placeholder = '',
  disabled = false,
  className,
}: Props<T>) => {
  const [isOpen, setIsOpen] = useState(false)
  const [activeItem, setActiveItem] = useState<number | null>(null)

  const handleDropdownItemClick = (item: Item<T>) => {
    onSelect(item)
    clean()
  }

  const clean = useCallback(() => {
    setActiveItem(null)
    setIsOpen(false)
  }, [])

  return (
    <Dropdown isOpen={isOpen} direction="down" toggle={() => setIsOpen(!isOpen)} className={className}>
      <DropdownToggle tag="div" data-toggle="dropdown" aria-expanded={isOpen} disabled={disabled}>
        <Input
          id={id}
          value={value}
          invalid={invalid}
          placeholder={placeholder}
          onBlur={onBlur}
          onChange={() => {}}
          disabled={disabled}
          className={`pe-4 ${styles.noCursor}`}
        />
        {!invalid && <i className={`icf-double_carot font-large ${styles.icon}`} />}
      </DropdownToggle>
      <DropdownMenu style={{ maxHeight: '200px', minWidth: '100%', maxWidth: '100%', overflow: 'auto' }}>
        {items.map((item, index) => {
          return (
            <DropdownItem
              key={`${id}-${index}`}
              className={`${styles.item} ${index === activeItem && styles.activeItem} text-truncate`}
              onClick={() => handleDropdownItemClick(item)}
              onMouseOver={() => setActiveItem(index)}
            >
              {item.value}
            </DropdownItem>
          )
        })}
      </DropdownMenu>
    </Dropdown>
  )
}
export default SelectBox
